<template>
    <Modal :visible="$userStore.isPermissionDeniedModalVisible" @close="closeModal">
        <div class="d-flex flex-column align-items-center justify-content-center">
            <i
                class="fi fi-lg fi-alert-circle mb-2"
                style="
                    font-size: 40px;
                    line-height: 40px;
                    font-weight: 200;
                    color: var(--danger);
                "
            ></i>
            <h2 class="my-1 text-center">Access Denied</h2>
            <div class="permission-description my-2 w-100" style="color: var(--neutral-800)">
                You do not have permission to access this feature. Please contact your company admin to enable this permission for you.
            </div>
            <div class="actions d-flex gap-2">
                <button class="btn btn-desktop-lg btn-primary w-100" @click="closeModal">
                    Close
                </button>
            </div>
        </div>
    </Modal>
</template>

<script>
import Modal from '@/components/Modal.vue';

export default {
    name: 'PermissionDeniedModal',
    components: {
        Modal,
    },
    props: {},
    emits: [],
    methods: {
        closeModal() {
            this.$userStore.togglePermissionDeniedModal(false);
        },
    },
};
</script>

<style scoped>
.permission-description {
    text-align: center;
    margin-bottom: var(--space-5);
}

.actions {
    margin-top: var(--space-5);
    width: 100%;
}

@media (max-width: 767.98px) {
    .actions {
        flex-direction: column;
        width: 100%;
    }
    .actions .btn {
        width: 100%;
    }
}
</style>
